<template>
  <autocomplete
    v-model="selectedCompanyProxy"
    :items="foodCompanies"
    dense
    filled
    :label="$t('select_company')"
    item-text="name"
    item-value="id"
    return-object
    clear
    chips
    small-chips
    :loading="loading.fetchFoodCompanies"
    :disabled="loading.fetchFoodCompanies"
  />
</template>

<script>
export default {
  name: "ReportFieldSelectFoodCompany",
  data() {
    return {
      loading: {
        fetchFoodCompanies: false,
      },
    };
  },
  computed: {
    selectedCompany: {
      get() {
        return this.$store.state.report.selectedCompany;
      },
      set(val) {
        this.$store.commit("report/SET_SELECTED_COMPANY", val);
      },
    },
    selectedCompanyProxy: {
      get() {
        return this.selectedCompany;
      },
      set(val) {
        this.selectedCompany = val;
      },
    },
    filters() {
      return this.$store.state.report.filters;
    },
    foodCompanies() {
      return this.$store.state.report.foodCompanies.map((company) => ({
        ...company,
        name: this.toLatin(company.name),
      }));
    },
    restaurantId() {
      return this.$store.state.restaurant.id;
    },
  },
  watch: {
    restaurantId: {
      handler(newVal) {
        if (!newVal || this.loading.fetchFoodCompanies) return;
        
        this.loading.fetchFoodCompanies = true;
        this.$store
          .dispatch("report/fetchFoodCompanies", {
            date_from: this.filters.dates.from,
            date_to: this.filters.dates.to,
            restaurant_id: newVal,
          })
          .then(() => {
            if (this.foodCompanies && this.foodCompanies.length) {
              if (!this.selectedCompany) {
                this.selectedCompany = this.foodCompanies[0];
              }
            }
          })
          .catch((error) => {
            console.error("Error fetching food companies:", error);
          })
          .finally(() => {
            this.loading.fetchFoodCompanies = false;
          });
      },
      immediate: true,
    },
  },
};
</script>
